import React, { useState, useEffect, useRef } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "./CreateItem.scss";
import { useForm } from "react-hook-form";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import NFTMarket from "../../../artifacts/contracts/NFTMarket.sol/NFTMarket.json";
import { useNavigate } from "react-router-dom";
import Api from "../../Common/api.jsx";
import { v4 as uuidv4 } from "uuid";
import { notifications } from "../../Helpers/Notifications";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MetaMaskService from "../../Common/metamaskService.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import Cropper from "react-cropper";
import ErrorHandler from "../../Helpers/ErrorHandler.jsx";
//import Button from '@material-ui/core/Button';

const CreateItem = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [videoEl, setVideoEl] = useState("");
  const [image, setImage] = useState("");
  const [fileError, setFileError] = useState(false);
  const [cropData, setCropData] = useState(undefined);
  const [cropper, setCropper] = useState();
  const [preview, setPreview] = useState(false);
  const [extension, setExtension] = useState(false);

  const [assetInfo, setAssetInfo] = useState();
  const [user, setUser] = useState();
  const [collections, setCollections] = useState([]);
  const [imgFile, setImgFile] = useState();
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [chainConfigs, setChainConfigs] = useState([]);
  const [selectedChainConfig, setSelectedChainConfig] = useState([]);
  const [showSwitchNetworkPopup, setShowSwitchNetworkPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });
    return () => window.removeEventListener("click", () => {});
  });

  useEffect(() => {
    try {
      // set loading to true before calling API
      setLoading(true);
      const chainConfigs = [];

      Object.entries(new CommonHelper().getAllChainConfigs()).forEach(
        (chainConfig) => {
          chainConfigs.push(chainConfig[1]);
        }
      );

      setChainConfigs(chainConfigs);

      setPreview(false);

      getAccount().then((account) => {
        getUserDetails(account);
        getCollections(account);
      });

      // switch loading to false after fetch is complete
      setLoading(false);
    } catch (error) {
      // add error handling here
      setLoading(false);
      console.log(error);
    }
  }, []);

  async function getAccount() {
    var account = await new MetaMaskService().getAccount();
    console.log(account);
    return account;
  }

  function getImage() {
    console.log(image);
    return image;
  }

  async function onChangeFun(e, forImage) {
    let t = this;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    setFileError(false);
    setExtension(false);
    console.log(Math.round(files[0]["size"] / 1024));

    const reader = new FileReader();
    reader.onload = () => {
      let fileName = files[0]["name"];
      let text = fileName.split(".").pop().toLowerCase();
      console.log(text);
      if (
        text === "png" ||
        text === "jpg" ||
        text === "jpeg" ||
        text === "svg" ||
        text === "gif"
      ) {
        //setVideoEl("");
        setImage(reader.result);
      } // } else if (text === "mp4" || text === "mp3") {
      //   setVideoEl(reader.result);
      //   setImage("");

      //}
      else {
        setExtension(true);
      }
      setPreview(true);
    };
    reader.readAsDataURL(files[0]);
  }

  async function getUserDetails(account) {
    const api = new Api();

    api
      .get("get_user_details/?account=" + account)
      .then((response) => {
        setUser(response.data[0]);
      })
      .catch((err) => console.log(err));
  }

  async function getCollections(account) {
    const api = new Api();

    api
      .get("/get_user_collections/?account=" + account)
      .then((response) => {
        //  console.log(response.data);
        setCollections(response.data);
      })
      .catch((err) => console.log(err));
  }

  async function checkImageVideo() {
    if (image == "" && videoEl == "") {
      setFileError(true);
    }
  }
  const onSubmit = async (data) => {
    setAssetInfo(data);
    console.log(image, videoEl);
    if (image == "" && videoEl == "") {
      setFileError(true);
      console.log(fileError);
      return 1;
    }
    if (errors && errors.length > 0) return;

    const chainConfig = new CommonHelper().getChainConfig(data.chainId);
    setSelectedChainConfig(chainConfig);
    if (window.ethereum.networkVersion != chainConfig.CHAIN_ID) {
      setShowSwitchNetworkPopup(true);

      return;
    }

    setIsSaving(true);
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();

    try {
      let contract = new ethers.Contract(
        chainConfig.NFT_MARKETPLACE_ADDRESS,
        NFTMarket.abi,
        signer
      );

      var tokenUri = uuidv4();

      contract.createToken(tokenUri).then(
        async (transactionDetails) => {
          //  console.log("saving asset for transaction", receipt);
          var tx = await transactionDetails.wait();
          const event = tx.events[0];
          const value = event.args[2];
          const tokenId = value.toNumber();
          //once transaction is successful, save it in db
          const asset = await saveInDb(data, tokenId, tx.transactionHash);
          notifications.success(
            `NFT ${asset.domain_name} created successfully`
          );
          //  console.log("asset", asset);
          navigate("/NftDetails/?assetId=" + asset.id);
        },
        (err) => {
          console.log(err);
          setIsSaving(false);
          new ErrorHandler().processEtherMessage(err);
        }
      );
    } catch (err) {
      setIsSaving(false);
      notifications.error("Something went wrong");
    }
  };

  async function saveInDb(data, tokenId, transactionHash) {
    try {
      const chainConfig = new CommonHelper().getChainConfig(data.chainId);
      var item = {
        owner_id: user.id,
        domain_name: data.name,
        latest_status: "Active",
        mint_user_id: user.id,
        desc: data.description,
        collection_id: data.collection ? parseInt(data.collection) : "",
        price: data.price,
        token_id: tokenId,
        image: image ? image : videoEl,
        chain_id: data.chainId,
        transaction_hash: transactionHash,
        currency: chainConfig.CURRENCY_SYMBOL,
        external_url: data.externalLink,
      };
      console.log(item);
      const api = new Api();
      var asset = await api.post("asset_details/", item);
      return asset.data;
    } catch (err) {
      setIsSaving(false);
      notifications.error("Something went wrong. " + err);
    }
  }

  function getPreview() {
    return preview;
  }
  async function onImageChange(e) {
    const [file] = e.target.files;
    // console.log("file", file);
    const base64 = await convertBase64(file);
    //console.log("base64", base64);
    setPreview(true);
    setImgFile(base64);
  }

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <>
      <Header
        showSwitchNetworkPopup={showSwitchNetworkPopup}
        network={selectedChainConfig?.NETWORK_NAME}
        chainId={selectedChainConfig?.CHAIN_HEX_ID}
        onPopupClose={() => {
          setShowSwitchNetworkPopup(false);
        }}
      />
      <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
      <section className="edit-profile">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container">
            <div className="edit-profile__form-wrapper">
              <div className="section-title">
                <h2>CREATE NEW ITEM</h2>
              </div>
              <div className="edit-profile__img">
                <div
                  className="edit-profile__img-uploaded"
                  style={{ display: image == "" ? "none" : "block" }}
                >
                  <img src={image} className="img_upload1 img" alt="" />
                  <video
                    width="320"
                    height="240"
                    style={{ display: videoEl == "" ? "none" : "block" }}
                    controls
                    src={videoEl}
                    type="video/mp4"
                  />
                  {/* <button>  */}
                  <label htmlFor="contained-button-file">
                    <input
                      type="file"
                      accept="image/*,audio/x-m4a,audio/*,video/mp4,video/x-m4v,video/*"
                      style={{ display: "none" }}
                      id="contained-button-file"
                      name="image"
                      onChange={(e) => onChangeFun(e, "")}
                    />
                    <img
                      src="../images/icons8-edit-96.png"
                      style={{ width: 35 + "px", height: 35 + "px" }}
                    />
                  </label>
                  {/* </button> */}
                </div>
                <div
                  className="edit-profile__img-uploadcls"
                  style={{
                    display: image != "" ? "none" : "block", //|| videoEl != "" ? "none" : "block",
                  }}
                >
                  <i className="material-icons-outlined">upload_file</i>
                  <h3>Upload Image, Video, Audio or 3D Model</h3>
                  <p>Drag or choose your file to upload</p>
                  <p>(JPG, PNG, GIF, SVG. Max 100 Mb.)</p>
                  <input
                    type="file"
                    name="image"
                    accept="image/*,audio/x-m4a,audio/*,video/mp4,video/x-m4v,video/*"
                    // {...register("image", {
                    //   required: "File is Required",
                    // })}
                    //onChange={(e) => onImageChange(e)}
                    onChange={(e) => onChangeFun(e, "")}
                  />
                </div>

                <p className="error">{fileError ? "File is Required" : ""}</p>
                <p className="error">
                  {extension ? "Please select valid format" : ""}
                </p>
              </div>
              <div className="edit-profile__form">
                <div className="form-group">
                  <label>
                    Item Name <span className="asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    autoComplete="off"
                    className="form-control"
                    readOnly={isSaving}
                    placeholder="Enter the name of your item"
                    {...register("name", {
                      required: "Name is Required",
                    })}
                  />
                  <p className="error">{errors.name?.message}</p>
                </div>
                <div className="form-group">
                  <label>External Link </label>
                  <input
                    type="text"
                    autoComplete="off"
                    name="externalLink"
                    className="form-control"
                    readOnly={isSaving}
                    placeholder="https://www.yoursite.io/item/123"
                    {...register("externalLink")}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <div className="form-control__wrapp">
                    <textarea
                      className="form-control textarea"
                      name="description"
                      autoComplete="off"
                      readOnly={isSaving}
                      placeholder="Enter a detailed description about yourself"
                      {...register("description")}
                    ></textarea>
                    <p className="error">{errors.description?.message}</p>
                  </div>
                </div>
                <div className="form-group">
                  <label>Collection</label>
                  <div className="form-control select-dd">
                    <select
                      style={{ background: "rgb(31 36 56)" }}
                      name="collection"
                      {...register("collection")}
                      disabled={isSaving}
                    >
                      <option value="">Select Collection</option>
                      {collections?.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.collection_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <p className="error">{errors.collection?.message}</p>
                </div>
                <div className="form-group">
                  <label>
                    Chain <span className="asterisk">*</span>
                  </label>
                  <div className="form-control select-dd">
                    <select
                      style={{ background: "rgb(31 36 56)" }}
                      name="chainId"
                      {...register("chainId", {
                        required: "Chain is Required",
                      })}
                      disabled={isSaving}
                    >
                      <option value="">Select Chain</option>
                      {chainConfigs?.map((e, key) => {
                        return (
                          <option key={key} value={e.CHAIN_ID}>
                            {e.NETWORK_NAME}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <p className="error">{errors.chainId?.message}</p>
                </div>
                {/* <div className="form-group">
                  <label>
                    Category <span className="asterisk">*</span>
                  </label>
                  <div className="form-control select-dd">
                    <select
                      name="category"
                      {...register("category", {
                        required: "Category is Required",
                      })}
                    >
                      <option value="">Select Category</option>
                      {categories?.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <p className="error">{errors.category?.message}</p>
                </div> */}

                {isSaving ? (
                  <div className="form-group__btn">
                    <div className="button btn-waiting ">
                      <img
                        className="loader"
                        src="../Loader/redshilliz-loader.gif "
                        alt="Coin"
                      />
                      Creating...
                    </div>
                  </div>
                ) : (
                  <div className="form-group__btn">
                    <input
                      type="submit"
                      onClick={checkImageVideo}
                      className="button"
                      value="Create"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </section>
      <Footer />
    </>
  );
};

export default CreateItem;
